import React, { Fragment, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { ISteps } from 'core/redux/features/booking/types';
import { useTrans } from 'core/hooks';

type IProps = {
  activeStep: number;
  steps: ISteps;
};

export default function StepsStatusBar({ steps, activeStep }: IProps) {
  const trans = useTrans();

  const stepEntries = useRef(Object.entries(steps));
  useEffect(() => {
    stepEntries.current = Object.entries(steps);
  }, [steps]);

  return (
    <ul className="steps">
      {stepEntries.current.map(([_, step], index) => {
        return (
          <Fragment key={step.id}>
            <li
              className={classNames(
                'text is-uppercase',
                index === activeStep && 'is-active',
                index < activeStep && 'is-done',
              )}
            >
              <span className="orb" />
              {trans(step.label)}
            </li>
            {index !== stepEntries.current.length - 1 ? (
              <li
                className={classNames('line', index < activeStep && 'is-done')}
              />
            ) : null}
          </Fragment>
        );
      })}
    </ul>
  );
}

// const mapStateToProps = (state: AppState) => {
//   return {
//     trans: selectTranslator(state),
//   }
// }
//
// const StepsStatusBar = connect(mapStateToProps)(StepsStatusBarComp)
// export default withRouter(StepsStatusBar)
